<template>

    <div class="container-fluid">
        <div class="row ">
            <div class="row">
                test
            </div>
        </div>
    </div>          
</template>

<script>
export default {
    name: 'footsecondary'
}
</script>

<style scooped>
    .test{
        background-color: yellow;
    }
</style>